class AccordionAnimation {
  constructor() {
    this.accordions = document.querySelectorAll('.accordion details');
    this.init();
  }

  init() {
    this.accordions.forEach((details) => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');
      
      if (!summary || !content) return;

      // Prevenir o comportamento padrão e controlar manualmente
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleAccordion(details, content);
      });
    });
  }

  toggleAccordion(details, content) {
    const isOpening = !details.hasAttribute('open');
    
    if (isOpening) {
      // Abrir
      details.setAttribute('open', '');
      
      // Calcula altura real do conteúdo
      const tempHeight = content.style.height;
      content.style.height = 'auto';
      const targetHeight = content.scrollHeight;
      content.style.height = tempHeight;
      
      // Inicia fechado
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
      content.style.marginBottom = '0px';
      
      // Força reflow para garantir que o estado inicial seja aplicado
      void content.offsetHeight;
      
      // Inicia animação
      details.classList.add('accordion-opening');
      content.style.maxHeight = targetHeight + 'px';
      content.style.opacity = '1';
      content.style.marginBottom = '1.5rem';
      
      // Limpa após animação
      const clearStyles = () => {
        if (details.hasAttribute('open')) {
          content.style.maxHeight = '';
          content.style.opacity = '';
          content.style.marginBottom = '';
          details.classList.remove('accordion-opening');
        }
      };
      setTimeout(clearStyles, 300);
      
      // Atualiza aria-expanded
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    } else {
      // Fechar
      const startHeight = content.scrollHeight;
      
      // Garante que está visível antes de animar
      content.style.maxHeight = startHeight + 'px';
      content.style.opacity = '1';
      
      // Força reflow
      void content.offsetHeight;
      
      // Inicia animação de fechamento
      details.classList.add('accordion-closing');
      details.removeAttribute('open');
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
      content.style.marginBottom = '0px';
      
      // Remove classes e limpa styles após animação
      setTimeout(() => {
        details.classList.remove('accordion-closing');
        content.style.maxHeight = '';
        content.style.opacity = '';
        content.style.marginBottom = '';
      }, 300);
      
      // Atualiza aria-expanded
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
  }
}

// Inicializa quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AccordionAnimation();
  });
} else {
  new AccordionAnimation();
}

